import { cloneDeep } from 'lodash';
import { ISearchRequestObject } from '@logz-build/typescript';
import { EventModel } from '@logz-pkg/models';
import { ruleApiService } from '../rule/api.service';

export const populate = {
  withMitreTags: async (events: EventModel[]): Promise<EventModel[]> => {
    const eventsCopy = cloneDeep(events);
    // an event that did not come from a rule (e.g. one an agent created) has no rule id and no tags to fetch
    const ruleIds = events.map(event => event.alertDefinitionId).filter((id): id is number => typeof id === 'number');

    if (ruleIds.length === 0) return eventsCopy;

    const searchRequestObject: ISearchRequestObject = {
      filter: { ruleIds },
      pagination: { pageSize: 1000, pageNumber: 1 },
    };
    const rulesTags = (await ruleApiService.search(searchRequestObject)).results.reduce(
      (acc, cur) => ({ ...acc, [cur.id]: cur.mitreTags }),
      {},
    );

    eventsCopy.forEach(event => {
      event.mitreTags = typeof event.alertDefinitionId === 'number' ? rulesTags[event.alertDefinitionId] ?? [] : [];
    });

    return eventsCopy;
  },
};
